import {createStyles, makeStyles} from '@material-ui/core/styles/';

export const skeletonLoaderUseStyles = makeStyles(() =>
  createStyles({
    outerWrapper: {
      width: '90%',
      margin: '0 auto'
    },

    tabContainer: {
      position: 'relative',
      marginTop: '30px',
      marginBottom: '30px',

      '&:before': {
        content: "' '",
        position: 'absolute',
        top: '70px',
        left: '-30px',
        right: '-30px',
        bottom: '-30px',
        background: '#f1f1f1'
      },

      '& .padL30': {
        paddingLeft: '30px !important'
      }
    },
    centerScreen: {
      width: '100%',
      margin: '10px auto'
    }
  })
);
